import * as React from "react";
const SvgEtchChannel = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 128 128", contentScriptType: "text/ecmascript", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M35 44h63v40H35z", style: {
  fill: "none",
  stroke: "#060",
  strokeWidth: 3
}, transform: "translate(-2.5)" }), /* @__PURE__ */ React.createElement("path", { d: "M14 29h100v72H14z", style: {
  fill: "none",
  stroke: "#f03",
  strokeWidth: 3
} }));
export default SvgEtchChannel;
